// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2bdSRSZ8ZfQZpVOAn0upPp","label":"_1vS5sBh51mAyDo1gZTeoCI"};